import axios from "axios";
import { jobsBus, isJobMutation } from "./jobsBus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => {
    // Flag the Schedule page to re-query after any successful job mutation.
    if (isJobMutation(res.config, res.status)) jobsBus.markChanged();
    return res;
  },
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail;
    if (
      status === 401 &&
      typeof detail === "string" &&
      (detail.includes("another device") || detail.toLowerCase().includes("session expired"))
    ) {
      localStorage.removeItem("mg_token");
      const path = window.location.pathname;
      if (!path.startsWith("/login")) {
        const reason = detail.includes("another device") ? "device" : "expired";
        window.location.href = `/login?reason=${reason}`;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
